// src/redux/reducers/sidebarReducer.js
import { TOGGLE_SIDEBAR } from '../actions/sidebarActions';

const initialState = {
  isSidebarCollapsed: true,
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarCollapsed: !state.isSidebarCollapsed,
      };
    default:
      return state;
  }
};

export default sidebarReducer;
